var exports = {
  "Nr": "UpdatePrompt.module__card___U0tqbX",
  "Ve": "UpdatePrompt.module__enter___U0tqbX",
  "Dr": "UpdatePrompt.module__cardMobile___U0tqbX",
  "aA": "UpdatePrompt.module__iconWrap___U0tqbX",
  "Kk": "UpdatePrompt.module__icon___U0tqbX",
  "rf": "UpdatePrompt.module__body___U0tqbX",
  "DD": "UpdatePrompt.module__title___U0tqbX",
  "Qq": "UpdatePrompt.module__text___U0tqbX",
  "ng": "UpdatePrompt.module__callWarning___U0tqbX",
  "MC": "UpdatePrompt.module__callWarningIcon___U0tqbX",
  "o1": "UpdatePrompt.module__actions___U0tqbX",
  "VN": "UpdatePrompt.module__close___U0tqbX",
  "ut": "UpdatePrompt.module__closeIcon___U0tqbX",
};

module.exports = exports;
